module.exports = __webpack_public_path__ + "static/media/img_dance09.67c13c4d.png";